import {convertDateInMillisecondsToFlightDate, convertDateTimeToFlightDate} from "../converter/dates";
import {DateTime} from "luxon";

/**
 * Constructs a query string to retrieve flight details using a flight number and flight date.
 *
 * @param {string | null} flightNumber - The flight number to be included in the query. Can be null.
 * @param {DateTime | number | string} date - The flight date to be included in the query.
 *        It can be a DateTime object, a timestamp in milliseconds, or a string representation of the date.
 * @returns {string} A query string in the format of `flightNumber=<flightNumber>&flightDate=<flightDate>`
 *                   where `<flightDate>` is derived based on the input `date` type.
 */
export const constructGetFlightByFlightNumberQuery = (flightNumber: string | null, date: DateTime | number | string) => {
    const firstPart = `flightNumber=${flightNumber}&`
    if (typeof date === 'number') return `${firstPart}flightDate=${convertDateInMillisecondsToFlightDate(date)}`
    if (typeof date === "object") return `${firstPart}flightDate=${convertDateTimeToFlightDate(date)}`
    return `${firstPart}flightDate=${date}`
}
